<template>
  <slide :burgerIcon="false" :crossIcon="false"  :isOpen="menuHamburguer"
   width="300" @closeMenu="toogleMenu" :closeOnNavigation="true">
    <ul class="flex flex-col justify-around h-3/4">
      <li v-for="(item, index) of menu" :key="item.title">
        <router-link v-if="item.router" class="list-item"
          :style="{'z-index': menu.length + 1 - index}" :to="{ name: item.name}">
          {{ $t(item.title) }}
        </router-link>
        <div class="list-item cursor-pointer" v-else
          :style="{'z-index': menu.length + 1 - index}"
          @click="openModal">
          {{$t(item.title)}}
        </div>
      </li>
    </ul>
  </slide>
</template>
<script>
import { mapGetters } from 'vuex';
import { Slide } from 'vue3-burger-menu';

export default {
  name: 'VerticalNav',
  props: {
    menu: {
      type: Array,
      required: true,
    },
  },
  components: {
    Slide,
  },
  methods: {
    toogleMenu() {
      this.$store.dispatch('TOGGLE_MENU_STATE', { value: false });
    },
    openModal() {
      this.$store.dispatch('TOGGLE_MODAL_STATE', { value: true });
    },
  },
  computed: {
    ...mapGetters(['menuHamburguer']),
  },
};
</script>
<style>
    .bm-menu {
      height: 100%; /* 100% Full-height */
      width: 0; /* 0 width - change this with JavaScript */
      position: fixed; /* Stay in place */
      z-index: 1000; /* Stay on top */
      top: 0;
      left: 0;
      background-color: var(--site-b); /* Black*/
      overflow-x: hidden; /* Disable horizontal scroll */
      padding-top: 60px; /* Place content 60px from the top */
      transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
    }

    .bm-overlay {
      background: rgba(0, 0, 0, 0.8);
    }
    .bm-item-list {
      height:100%;
    }

     .list-item {
  font-family: 'VT323', monospace;
  font-weight: 400;
  font-size: 1.4em;
  background: var(--site-bll);
  color: var(--site-t);;
  text-align: center;
  height: 2em;
  width: 7em;
  line-height: 2em;
  border-bottom: 1px solid var(--site-bll);
  position: relative;
  display: block;
  text-decoration: none;
  box-shadow: -1em .8em 0 var(--site-bl);
  transition: all .25s linear;
  text-transform: uppercase;
  margin-left:1em;
}

.list-item:hover {
  background:  var(--site-bl);
  color:  var(--site-t);
  transform: translate(.5em, -.5em);
  transition: all .25s linear;
  box-shadow: -2em 1.5em 0  var(--site-bll);
  font-weight: bold;

}

.list-item:hover:before, .list-item:hover:after {
  transition: all .25s linear;
}

.list-item:hover:before {
  background:  var(--site-rl);
    width: 1em;
    top: .5em;
    left: -1em;
}

.list-item:hover:after {
  background:  var(--site-r);
  width: 1em;
  bottom: -4em;
  left: 2.5em;
  height: 7em;
}

.list-item:before, .list-item:after {
  content: '';
  position: absolute;
  transition: all .25s linear;
  width: .5em;
}

.list-item:after {
  height: 7em;
  background: var(--site-r);
  bottom: -3.8em;
  left: 3em;
  transform: rotate(90deg) skew(0,45deg);
}

.list-item:before {
  height: 2em;
  background:  var(--site-rl);
  top: .2em;
  left: -.5em;
  transform: skewY(-45deg);
}
</style>
